import TextField from 'material-ui/TextField';
import React, {PropTypes} from 'react';

export default function Input({id, name, label, textFieldRef, ...props}) {
  return (
    <div>
      <TextField hintText={label} id={id} name={name || id} ref={textFieldRef} {...props} />
      <br />
    </div>
  );
}

Input.propTypes = {
  disabled: PropTypes.bool,
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  readOnly: PropTypes.bool,
  textFieldRef: PropTypes.func,
  type: PropTypes.oneOf(['text', 'password']).isRequired,
  value: PropTypes.string.isRequired
};



// WEBPACK FOOTER //
// ./app/features/shared/components/Input.js